<template>
  <div class="phone-wrap">
    <div class="icon-cont">
      <div v-for="(iconItem, index) in data" :key="index">
        <el-image v-show="showOpen === 1 || iconItem.isAloneConfig === 1" :src="iconItem.iconImage || defaultImg" class="icon-img" />
      </div>
      <el-image
        v-show="isEnable" :src="showOpen == 1 ? openIcon : closeIcon" class="icon-img"
        @click="() => (showOpen = showOpen == 1 ? 2 : 1)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopDisplayOpenAd',
  props: ['data', 'openIcon', 'closeIcon', 'isEnable'],
  data() {
    return {
      showOpen: 1, // 1 显示展开图标 2 显示关闭图标
      defaultImg: 'https://ssl-picture.tenyun.runsasoft.com/2d97c9b0-83ab-11ea-b0d5-8b89156e3a17',
    };
  },
};
</script>

<style lang="less" scoped>
.phone-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  height: calc(100% - 40px);
  background-color: #f9f9f9;
  position: relative;
  border: 1.5px solid rgba(0, 0, 0, 0.2);
  .icon-cont {
    position: absolute;
    bottom: 0px;
    right: 0;
    margin: 20px;
    .icon-img {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      margin-bottom: 10px;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      background: #dddddd;
    }
  }
}
</style>
